import { render, staticRenderFns } from "./ThemeWizardForm.vue?vue&type=template&id=4f4d6a5a&scoped=true&"
import script from "./ThemeWizardForm.vue?vue&type=script&lang=js&"
export * from "./ThemeWizardForm.vue?vue&type=script&lang=js&"
import style0 from "./ThemeWizardForm.vue?vue&type=style&index=0&id=4f4d6a5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4d6a5a",
  null
  
)

export default component.exports